import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  ALTERNATEROW_BACKGROUND_COLOR,
  BLUE_COLOR, LIGHTGRAY_COLOR,
  MODIFIEDBLACK,
  PINK_COLOR,
  PROTECT_GREEN,
  RED_COLOR,
  VIBRANT_GREEN,DARKGREEN_COLOR,
  LIGHTGREEN_COLOR
} from "../constants";

export const IdleTimeOutModal = ({showModal, handleClose, handleLogout, remainingTime}) => {

    return (
        <Dialog
        open={showModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ fontSize: "20px", fontFamily: 'Globerbold', color: BLUE_COLOR }}>{"You Have Been Idle!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style= {{ fontFamily: 'Globerbold' }}>
          You are going to get Logout. Do You want to Stay or Logout ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          
          <Button variant={'text'} onClick={handleClose} style={{ color: 'white', fontFamily: 'Globerbold', backgroundColor: VIBRANT_GREEN, width: '30%', fontSize: 18 }}>
                                            STAY
          </Button>
          <Button variant={'text'} onClick={handleLogout} style={{ color: 'white', marginLeft:'10px', fontFamily: 'Globerbold', backgroundColor: RED_COLOR, width: '30%', fontSize: 18 }}>
                                            LOGOUT
          </Button>
        </DialogActions>
      </Dialog>
    )
}